export const config = {
  regText: {
    dropShadow: true,
    dropShadowAlpha: 0.5,
    dropShadowAngle: 1,
    dropShadowBlur: 1,
    dropShadowColor: '#3d1e00',
    dropShadowDistance: 3,
    fill: [
      '#fdff75',
      '#ff830f',
    ],
    stroke: '#ffffff',
    strokeThickness: 1,
    fontFamily: 'Palatinolinotype Bold',
  },
  symbolText: {
    dropShadow: true,
    dropShadowAngle: 1.9,
    dropShadowBlur: 10,
    fill: '#86ff69',
    fontFamily: 'Impact',
    fontSize: 49,
    fontWeight: 'bold',
    letterSpacing: 2,
    stroke: '#943b00',
  },

}
